export type AuthSession = {
  authenticated: boolean;
  steamId?: string;
  displayName?: string;
  avatarUrl?: string;
  playerUid?: string;
  roles: string[];
  permissions?: string[];
};

declare global {
  interface Window {
    __APP_CONFIG__?: {
      REACT_APP_API_BASE_URL?: string;
    };
  }
}

export const getApiBaseUrl = () => window.__APP_CONFIG__?.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '';

export const buildApiUrl = (path: string) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const baseUrl = getApiBaseUrl();
  return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath;
};

export const buildSteamLoginUrl = () => {
  const baseUrl = getApiBaseUrl();
  if (baseUrl) {
    return `${baseUrl}/api/auth/steam/login`;
  }
  return '/api/auth/steam/login';
};

export const hasAdminAccess = (session: AuthSession | null) => {
  if (!session?.authenticated) {
    return false;
  }
  return session.roles.includes('ADMIN') || session.roles.includes('MODERATOR');
};

export const isAuthenticatedSession = (session: AuthSession | null) => Boolean(session?.authenticated);
